import { keys } from './keys';

export const en = {
  [keys.required]: 'Please fill in this mandatory field',
  [keys.email]: 'Please enter a valid email address',
  [keys.isTrue]: 'You must accept the privacy policy',
};
